import moment from "moment";

export const compareDate = (a = new Date(),b = new Date()) => {
    return a.getDate()===b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
}

export const returnMonth = (a = new Date()) => {
    return moment(a.toISOString()).format('MMM');
}

export const returnWeek = (a = new Date()) => {
    return moment(a.toISOString()).format('ddd');
}

export const getADayFromNow = (a = 0) => {
    return new Date(Date.now() + (24 * 3600 * 1000 * a));
}

export const getADayFromDay = (date = new Date(),a = 0) => {
    return new Date(date.getTime() + (24 * 3600 * 1000 * a));
}

export const timeLine = () => {
    return [
        { label: '12:00 AM', value: '00:00:00' },
        { label: '01:00 AM', value: '01:00:00' },
        { label: '02:00 AM', value: '02:00:00' },
        { label: '03:00 AM', value: '03:00:00' },
        { label: '04:00 AM', value: '04:00:00' },
        { label: '05:00 AM', value: '05:00:00' },
        { label: '06:00 AM', value: '06:00:00' },
        { label: '07:00 AM', value: '07:00:00' },
        { label: '08:00 AM', value: '08:00:00' },
        { label: '09:00 AM', value: '09:00:00' },
        { label: '10:00 AM', value: '10:00:00' },
        { label: '11:00 AM', value: '11:00:00' },
        { label: '12:00 PM', value: '12:00:00' },
        { label: '01:00 PM', value: '13:00:00' },
        { label: '02:00 PM', value: '14:00:00' },
        { label: '03:00 PM', value: '15:00:00' },
        { label: '04:00 PM', value: '16:00:00' },
        { label: '05:00 PM', value: '17:00:00' },
        { label: '06:00 PM', value: '18:00:00' },
        { label: '07:00 PM', value: '19:00:00' },
        { label: '08:00 PM', value: '20:00:00' },
        { label: '09:00 PM', value: '21:00:00' },
        { label: '10:00 PM', value: '22:00:00' },
        { label: '11:00 PM', value: '23:00:00' }
      ];      
};

export const compareTime = (a = '12:00:00',b = '12:00:00')=> {
    const arr1 = a.split(':');
    const arr2 = b.split(':');
    if(arr1.length === 3 && arr2.length === 3 && !isNaN(Number(arr1[0])) && !isNaN(Number(arr2[0]))){
        // console.log(arr1,arr2);
        if(Number(arr1[0]) === Number(arr2[0])){
            return true;
        }else{
            return false;
        }
    }else{
        return false;
    }
}

export const dayOfWeek = ['SUN','MON','TUE','WED','THU','FRI','SAT'];

export const returnStaffColor = [
    '#cbe4f9',
    '#cdf5f5',
    '#eff9da',
    '#f9eade',
    '#f9dad6',
    '#d5cdea',
];